import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';


import { LoraRootModule } from './app/lora-root.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(LoraRootModule);



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/main.ts